.tile {
  position: relative;
  box-sizing: border-box;
  text-decoration: none;
  border: 1px solid #ddd;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  height: 370px;
  min-width: 300px;
  max-width: 350px;
  flex: 1;

  transition:
    box-shadow 240ms ease,
    transform 240ms ease;
}

.tile:hover {
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.28);
  transform: translateY(-1px);
}

.tile img {
  width: 100%;
  object-fit: cover;
  display: block;
  margin-bottom: 15px;
  max-height: 160px;
}

.tileContent {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  position: relative;
  padding: 20px;
  text-align: left;
  height: 100%;
}

.tileContent a {
  text-decoration: none;
}

.tileContent a:hover .tileTitle,
.tileContent a:focus-visible .tileTitle {
  text-decoration: underline;
  text-decoration-color: LinkText;
}

.tileContent a:visited:hover .tileTitle {
  text-decoration-color: VisitedText;
}

.tileTitle {
  margin: 15px 0 10px;
  font-size: var(--font-size-md);
  color: #333;
  font-weight: 600;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  line-clamp: 2;
  -webkit-line-clamp: 2;
  overflow: hidden;
  min-height: calc(var(--font-size-md) * 2);
  line-height: 1.2;
}

.tileDescription {
  font-size: var(--font-size-sm);
  color: #4a4a4a;
  font-family: sans-serif;
  line-height: 1.5;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  line-clamp: 3;
  -webkit-line-clamp: 3;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 0;
  padding: 0;
}

.bookmarkButton {
  background: none;
  border: none;
  cursor: pointer;
  padding: 10px;
  position: absolute;
  bottom: 5px;
  right: 10px;
  font-size: 24px;
}

.bookmarkIcon {
  transition:
    transform 120ms ease,
    color 160ms ease;
}

.bookmarkButton:hover {
  animation: bookmark-wiggle 180ms ease-out;
}

@keyframes bookmark-wiggle {
  0% {
    transform: rotate(0);
  }

  33% {
    transform: rotate(-10deg);
  }

  66% {
    transform: rotate(10deg);
  }

  100% {
    transform: rotate(0);
  }
}

.bookmarkButton:active .bookmarkIcon {
  transform: scale(0.85);
}

.bookmarkIconWhite {
  color: #ccc;
}

.bookmarkIconBlue {
  color: #084b8a;
}

@media (max-width: 768px) {
  .tile {
    width: 310px;
    height: 260px;
    border-radius: 8px;
  }

  .tileContent {
    padding: 10px;
  }

  .tileTitle {
    font-size: 1em;
    margin: 10px 0 5px;
  }

  .tileDescription {
    font-size: 0.85em;
    line-clamp: 3;
    -webkit-line-clamp: 3;
    min-height: calc(1.5em * 3);
  }

  .bookmarkButton {
    font-size: 20px;
    bottom: 75px;
    right: 10px;
  }
}
